import { stringifyUrlQuery } from 'helpers';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import { parseIncomeData } from '../helpers';
import type {
  GetCompanyFromGusRequestType,
  GetCompanyFromGusResponseType,
} from '../types';

export const getCompanyFromGus = async ({
  queryParams: { nip },
}: GetCompanyFromGusRequestType) => {
  const query = stringifyUrlQuery({
    nip,
  });
  const url = `/company/gusapi${query}`;

  const { data } = await apiAuthClient.get<GetCompanyFromGusResponseType>(url);

  return parseIncomeData(data.data || {});
};
